const balanceAccountsTable = {
  columns: {
    getColumnsData: 'balanceAccountsColumnsData',
    setColumnsData: 'setBalanceAccountsColumnsData'
  },
  rows: {
    getRowsData: 'balanceAccountsRowsData',
    setRowsData: 'setBalanceAccountsRowsData'
  }
}

const balanceAccountsTableColumns = [
  {
    id: 1,
    title: 'NAME',
    property: 'name'
  },
  {
    id: 2,
    title: 'CREDIT, AED',
    editable: true,
    inputs: ['debit', 'credit'],
    typeEditable: 'inputNumber',
    property: 'credit',
    actions: {
      edit: true
    },
    noNull: true
  },
  {
    id: 3,
    title: 'DEBIT, AED',
    editable: true,
    inputs: ['debit', 'credit'],
    typeEditable: 'inputNumber',
    property: 'debit',
    actions: {
      edit: true
    },
    noNull: true
  },
  {
    id: 4,
    title: 'BALANCE, AED',
    property: 'balanceAED'
  },
  {
    id: 5,
    property: 'action',
    inputs: ['debit', 'credit'],
    actions: {
      edit: true
    },
    toolbar: {
      hideEditBtn: false,
      hideDeleteBtn: true
    }
  }
]

export {balanceAccountsTable, balanceAccountsTableColumns}



// WEBPACK FOOTER //
// ./src/constants/TablesOptions/balanceAccountsTable.js